import { useRouter } from "next/router";
import { useContext } from "react";
import { FaChevronUp } from "../Atoms/AppIcons";
import ScrollToTop from "react-scroll-to-top";
import useWindowSize from "../../utils/useWindowSize";
import EbookStickyBox from "../Cards/EbookForm/EbookStickyBox";
import Footer from "./Footer";
import Header from "./Header";
import PageMain from "./PageMain";
import { LayoutType } from "./constants";
import { LayoutContext } from "./provider";

interface LayoutProps {
  children: React.ReactNode;
}
export default function Layout({ children }: LayoutProps) {
  const { width } = useWindowSize();
  const router = useRouter();

  const scrollBtn = {
    background: "#fff",
    width: 36,
    borderRadius: "50%",
    height: 36,
    padding: 0,
    border: "none",
  };

  const context = useContext(LayoutContext);
  const { type } = context.state;
  const isPortalRoute =
    router.pathname === "/portal" || router.pathname.startsWith("/portal/");

  return (
    <>
      <Header />
      <PageMain>{children}</PageMain>
      {width > 768 && <EbookStickyBox />}

      {!isPortalRoute && type !== LayoutType.HideScrollTop && (
        <ScrollToTop
          smooth
          component={<FaChevronUp size={26} color="#cb5a5a" />}
          style={
            width <= 768
              ? { ...scrollBtn, bottom: 100, right: 10 }
              : { ...scrollBtn, bottom: 100, right: 40 }
          }
        />
      )}
      {!isPortalRoute && <Footer />}
    </>
  );
}
